{
    "DefaultErrorMessage":{
        "message" :"Unknown error Occured"
    },
    "401": {
        "message" : "Incorrect credentials i.e username or password"
    },
    "0": {
        "message": "Unknown Error"
    },
    "200":{
        "message":"Successfully"
    },
    "201":{
        "message": "Created successfully"
    },
    "423":{
        "message": "Account Locked"
    },
    "404":{
        "message": "The requested  was not found on this server"
    },
    "503":{
        "message":"Service Unavailable error"
    },
    "500":{
        "message": "Internal Server  Error"
    }




}